var _effectorFileName = "/builds/gmini/front-common/src/metrika/env.ts";
import "core-js/modules/esnext.global-this.js";
// TODO: remove envs from library
export var yandexMetrikaDisabled = parseBoolEnv(getEnv('SPA_YANDEX_METRIKA_DISABLED'));

function getEnv(name) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var value = globalThis[name] || '';
  return value;
}

function parseBoolEnv(value) {
  switch (value) {
    case 'true':
      return true;

    case 'false':
      return false;

    default:
      return null;
  }
}